<script lang="ts">
    export let date: Date;
</script>

<time itemprop="datePublished" datetime={date.toISOString().substring(0, 10)}
    >{date.toLocaleDateString('en', { dateStyle: 'long' })}</time
>
